import styled from 'styled-components'

export const OperationCardContainer = styled.div`
    .header-wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    display: flex;
    flex-direction: column;
    font-size: 13px;

    gap: 12px;
    padding-left: 12px;
    font-family: var(--font-regular);

    .bowtie-list {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .bowtie-name {
            padding-left: 20px;
            display: flex;
            font-size: 13px;
            justify-content: center;
            gap: 6px;
            font-family: var(--font-regular);
        }
    }
`
